export default {
    parts: [
        'orderDetailHeading',
        'orderStatusText',
        'orderStatusInfoText',
        'orderNumberText',
        'orderNuberValue',
        'OrderDateText',
        'InStoreAddressLable',
        'InStoreAddress',
        'orderDateValue',
        'orderReturnStatusText',
        'brandNameText',
        'quantityPriceText',
        'quantityPriceShippingText',
        'saleOnText',
        'colorText',
        'sizeText',
        'lenghtText',
        'styleNumberText',
        'shippingAddressMainContainer',
        'shippingNameText',
        'shippingAddressHeading',
        'shippingMethodHeading',
        'shippingMethodText',
        'shippingMethodNumber',
        'shippingMethodbusinessDaysText',
        'shippingMethodStoreInfo',
        'paymentMethodContainer',
        'paymentMethodText',
        'paymentCardNameText',
        'paymentCardNumberText',
        'paymentCardDateText',
        'giftCardContainer',
        'giftCardAmount',
        'billingAddressHeading',
        'billingNameText',
        'billingStreetText',
        'billingPostalAddresText',
        'billingCountryText',
        'billingPhoneNoText',
        'brandNameShippingText',
        'orderSummmaryHeadingText',
        'orderSummarySubtotalText',
        'orderSummaryCurrencyText',
        'orderSummaryShippingText',
        'orderSummaryTotalHeading',
        'orderSummaryTotalValueText',
        'productAttributesText'
    ],
    baseStyle: (props) => ({
        orderDetailHeading: {
            fontSize: {base: '20px', lg: '24px'},
            fontWeight: '700',
            fontFamily: 'GarageNeue',
            lineHeight: {base: '24px', lg: '30px'},
            textTransform: 'uppercase'
        },
        orderStatusText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '700',
            textTransform: 'uppercase',
            lineHeight: {base: '16px', lg: '20px'}
        },
        orderStatusInfoText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '11', lg: '12'},
            fontWeight: '500',
            textTransform: 'uppercase',
            lineHeight: {base: '18px', lg: '18px'}
        },
        orderNumberText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '700',
            textTransform: 'uppercase',
            lineHeight: {base: '16px', lg: '20px'}
        },
        orderNuberValue: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            color: '#585858'
        },
        OrderDateText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '700',
            textTransform: 'uppercase',
            lineHeight: {base: '16px', lg: '20px'}
        },
        InStoreAddressLable: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '700',
            textTransform: 'uppercase',
            lineHeight: {base: '16px', lg: '20px'}
        },
        InStoreAddress: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            color: '#585858'
        },
        orderDateValue: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            color: '#585858'
        },
        orderReturnStatusText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '14', lg: '16'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        brandNameShippingText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '12'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '18px'},
            textTransform: 'uppercase',
            color: '#676767'
        },
        shippingEmailText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        brandNameText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '500',
            lineHeight: {base: '18px', lg: '20px'},
            textTransform: 'Capitalize'
        },
        quantityPriceText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: {base: '400', lg: '500'},
            lineHeight: {base: '18px', lg: '20px'},
            textTransform: 'uppercase'
        },
        quantityPriceShippingText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: {base: '500', lg: '500'},
            lineHeight: {base: '18px', lg: '20px'},
            textTransform: 'uppercase'
        },
        saleOnText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            textDecoration: 'line-through',
            color: 'gray.500'
        },
        colorText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        sizeText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        lenghtText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        styleNumberText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        shippingAddressMainContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItem: 'flexStart',
            padding: '16px',
            gap: '8px',
            border: '1px solid #ECE9E9'
        },
        shippingNameText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            textTransform: 'Capitalize'
        },
        shippingAddressHeading: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '14px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        shippingMethodHeading: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '14px', lg: '16px'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        shippingMethodText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '16px', lg: '20px'},
            textTransform: 'uppercase'
        },
        shippingMethodNumber: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        shippingMethodbusinessDaysText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'},
            marginTop:"2px"
        },
        shippingMethodStoreInfo: {
            fontFamily: 'GarageNeue',
            fontSize: { base: '12px', lg: '14px' },
            fontWeight: '400',
            lineHeight: { base: '18px', lg: '20px' },
            marginTop: "4px"
        },
        paymentMethodContainer: {
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid',
            borderColor: 'gray.200',
            gap: '16px',
            padding: '20px'
        },
        paymentMethodText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '14px', lg: '16px'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        paymentCardNameText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '16px', lg: '20px'},
            textTransform: 'uppercase'
        },
        paymentCardNumberText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '18px', lg: '20px'}
        },
        paymentCardDateText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        giftCardContainer: {
            width: '100%',
            flexDirection: 'column',
            alignItems: 'start',
            padding: '16px',
            border: '1px solid',
            borderColor: 'gray.200'
        },
        giftCardAmount: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        billingAddressHeading: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '16px', lg: '20px'},
            textTransform: 'uppercase'
        },
        billingNameText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        billingStreetText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        billingPostalAddresText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        billingCountryText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        billingPhoneNoText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        orderSummmaryHeadingText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '16px', lg: '20px'},
            textTransform: 'uppercase'
        },
        orderSummarySubtotalText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        orderSummaryCurrencyText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        orderSummaryShippingText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12px', lg: '14px'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        },
        orderSummaryTotalHeading: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '14px', lg: '16px'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        orderSummaryTotalValueText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '14px', lg: '14px'},
            fontWeight: '700',
            lineHeight: {base: '20px', lg: '20px'},
            textTransform: 'uppercase'
        },
        productAttributesText: {
            fontFamily: 'GarageNeue',
            fontSize: {base: '12', lg: '14'},
            fontWeight: '400',
            lineHeight: {base: '18px', lg: '20px'}
        }
    })
}